const computeVacationsForEvent = require('./computeVacationForEvent');

module.exports = function (events, startDate, endDate) {
  return events.reduce((total, event) => total + computeVacationsForEvent(event, startDate, endDate), 0);
};